import { Reveal, ChapterHead, CHAKRAS } from "./shared";

export default function Chakras() {
  return (
    <section id="chakras" className="py-20 lg:py-32" data-testid="chakras-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-16">
          <ChapterHead number="03" label="Symbolism" title="The Seven Chakras" testid="chakras" />
          <Reveal delay={0.15}>
            <p className="mt-6 text-base sm:text-lg text-[#1A201C]/70 leading-relaxed" data-testid="chakras-intro">
              In traditional chakra philosophy, each chakra is represented by a colour
              and associated with particular qualities and areas of personal reflection.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CHAKRAS.map((c, i) => (
            <Reveal key={c.key} delay={(i % 4) * 0.1} className={i === 0 ? "sm:col-span-2 lg:col-span-2" : ""}>
              <article
                className="group relative h-full border border-[#1B1915]/12 bg-white/50 rounded-sm p-7 overflow-hidden hover:-translate-y-1.5 hover:bg-white transition-[transform,background-color,border-color] duration-500 hover:border-[#1B1915]/25"
                data-testid={`chakra-card-${c.key}`}
              >
                <span
                  className="absolute top-0 left-0 right-0 h-[3px]"
                  style={{ backgroundColor: c.hex }}
                />
                <span
                  className="absolute -top-12 -right-12 w-40 h-40 rounded-full blur-3xl opacity-0 group-hover:opacity-25 transition-opacity duration-700 pointer-events-none"
                  style={{ backgroundColor: c.hex }}
                />
                <div className="flex items-start justify-between mb-8 mt-1">
                  <span
                    className={`w-3 h-3 rounded-full mt-1 ${c.light ? "border border-[#1B1915]/25" : ""}`}
                    style={{ backgroundColor: c.hex }}
                  />
                  <span className="font-serif-display italic text-2xl text-[#1B1915]/20">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-serif-display text-xl text-[#1B1915] tracking-tight">
                  {c.name}
                </h3>
                <p className="text-[11px] tracking-[0.22em] uppercase text-[#8C7A56]/70 mt-1 mb-6">
                  Colour — {c.colour}
                </p>
                <ul className="space-y-1.5">
                  {c.traits.map((t) => (
                    <li key={t} className="text-sm text-[#1A201C]/65 flex items-center gap-2.5">
                      <span className="w-1 h-1 rounded-full border border-[#1B1915]/10" style={{ backgroundColor: c.hex }} />
                      {t}
                    </li>
                  ))}
                </ul>
                <p className="mt-5 font-serif-display italic text-base text-[#1A201C]/60 leading-snug">
                  {c.desc}
                </p>
                <p className="mt-6 text-[10px] tracking-[0.18em] uppercase text-[#1A201C]/40">
                  Traditional symbolism
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
